(() => {
  const root = (document.body.dataset.rootUrl || '/').replace(/\/?$/, '/');
  if (document.body.dataset.template === '404' && document.body.dataset.referencePreview === 'true') {
    fetch(document.body.dataset.previewRoutes).then(r=>r.json()).then(routes=>{
      const target=routes[location.pathname];
      if (target) {
        const url=new URL(target,location.origin);
        const current=new URL(location.href);
        for (const key of ['preview_theme_id','pb']) if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));
        location.replace(url);
      }
    }).catch(()=>{});
  }
  let returnFocus;
  let previewRoutes = {};
  if (document.body.dataset.referencePreview === 'true') {
    fetch(document.body.dataset.previewRoutes).then(r=>r.json()).then(routes=>{
      previewRoutes=routes;
    }).catch(()=>{});
  }
  const note = 'This reference product has not been imported into this store yet. No item was added.';
  const message = text => {
    let dialog = document.getElementById('ReferenceMessage');
    if (!dialog) {
      dialog = document.createElement('dialog'); dialog.id = 'ReferenceMessage';
      dialog.innerHTML = '<button type="button" data-close-dialog aria-label="Close">×</button><p role="status"></p>';
      document.body.appendChild(dialog);
    }
    dialog.querySelector('p').textContent = text;
    returnFocus = document.activeElement; dialog.showModal();
  };
  const escapeHtml = value => String(value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const updateCartCount = count => {
    document.querySelectorAll('[data-cart-count],.js-cart-count').forEach(el => el.textContent = count);
    document.querySelectorAll('[data-cart-count-label]').forEach(el => el.textContent = count + (count === 1 ? ' item' : ' items'));
    document.querySelectorAll('[data-cart-count-badge]').forEach(el => el.hidden = count === 0);
  };
  document.addEventListener('reference:cart-updated', event => updateCartCount(event.detail.item_count));
  document.addEventListener('reference:cart-added', event => openCartDrawer(null,event.detail));
  let cartAddTask = null;
  let cartRevision = 0;
  async function refreshCart(currentCart) {
    const body=document.querySelector('[data-reference-cart-body]');
    const revision=++cartRevision;
    try {
      let cart=currentCart;
      if(!cart){
        const response=await fetch(root+'cart.js');if(!response.ok)throw new Error('Unable to load your cart.');
        cart=await response.json();
      }
      if(revision!==cartRevision)return false;
      if(window.BobboOffers?.reconcile)cart=await window.BobboOffers.reconcile(cart);
      if(revision!==cartRevision)return false;
      const money=value=>new Intl.NumberFormat('en-US',{style:'currency',currency:cart.currency}).format(value/100);
      updateCartCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('reference:cart-updated',{detail:cart}));
      if(!body)return true;
      if(window.BobboOffers?.renderDrawer){window.BobboOffers.renderDrawer(cart);return true;}
      body.classList.toggle('middle-xs',!cart.item_count);body.classList.toggle('center-xs',!cart.item_count);
      if(!cart.item_count) {body.innerHTML='<div class="bobbo-drawer-empty"><span class="h5 mb-32">Your cart is empty</span><a class="btn btn-primary--animate btn-large" href="'+(previewRoutes['/collections/all']||root+'collections/all')+'"><span class="d-block o-hidden p-relative"><span class="btn-primary__content">Continue shopping</span></span></a></div>';return true;}
      body.innerHTML='<div class="bobbo-drawer-lines">'+cart.items.map(item=>'<article class="reference-drawer-line">'+(item.image?'<a href="'+escapeHtml(item.url)+'"><img src="'+escapeHtml(item.image)+'" alt="'+escapeHtml(item.product_title)+'"></a>':'')+'<div class="reference-drawer-line__info"><a class="reference-drawer-line__title" href="'+escapeHtml(item.url)+'">'+escapeHtml(item.product_title)+'</a><p class="subtext">'+escapeHtml(item.variant_title||'')+'</p><p class="reference-drawer-line__price">'+money(item.final_line_price)+'</p><div class="reference-drawer-line__actions"><div class="bobbo-quantity" data-cart-quantity><button type="button" data-cart-quantity-step="-1" aria-label="Decrease quantity">−</button><input type="number" min="0" value="'+item.quantity+'" data-cart-line="'+escapeHtml(item.key)+'" aria-label="Quantity"><button type="button" data-cart-quantity-step="1" aria-label="Increase quantity">+</button></div><button type="button" class="bobbo-cart-remove" data-cart-remove="'+escapeHtml(item.key)+'">Remove</button></div></div></article>').join('')+'</div><div class="bobbo-drawer-summary"><div><span>Subtotal</span><strong>'+money(cart.total_price)+'</strong></div><p class="subtext">U.S. shipping: $5.99 under $99; free on orders $99+. Taxes calculated at checkout.</p><div data-bobbo-cart-offers>'+ (window.BobboOffers?.markup ? window.BobboOffers.markup(cart) : '') +'</div><a class="btn btn-secondary--animate btn-large w-100" href="'+root+'cart"><span class="d-block o-hidden p-relative"><span class="btn-secondary__content">View cart</span></span></a><a class="btn btn-primary--animate btn-large w-100" href="'+root+'checkout"><span class="d-block o-hidden p-relative"><span class="btn-primary__content">Check out</span></span></a><p role="status" data-cart-error></p></div>';
      return true;
    } catch(error) {
      if(revision!==cartRevision)return false;
      if(body)body.innerHTML='<p role="status">'+escapeHtml(error.message)+'</p><a href="'+root+'cart">View cart</a>';
      const footer=document.querySelector('[data-reference-cart-footer]');if(footer)footer.hidden=true;
      return false;
    }
  }
  if(window.BobboOffers)window.BobboOffers.refreshDrawer=refreshCart;
  async function updateCart(key,quantity) {
    const offers=window.BobboOffers;
    const pending=(offers?.pendingUpdate || Promise.resolve()).then(()=>performCartUpdate(key,quantity));
    if(offers)offers.pendingUpdate=pending;
    await pending;
    if(offers?.pendingUpdate===pending)offers.pendingUpdate=null;
  }
  async function performCartUpdate(key,quantity) {
    const body=document.querySelector('[data-reference-cart-body]');
    document.body.classList.add('bobbo-cart-busy');
    document.querySelectorAll('[data-reference-cart-body] input,[data-reference-cart-body] button,.bobbo-cart-form input,.bobbo-cart-form button').forEach(el=>el.disabled=true);
    try {
      const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});
      const result=await response.json();if(!response.ok)throw new Error(result.description||'Unable to update your cart.');
      return await refreshCart(result);
    } catch(error){document.querySelectorAll('[data-cart-error]').forEach(el=>el.textContent=error.message);return false;}
    finally{document.body.classList.remove('bobbo-cart-busy');document.querySelectorAll('[data-reference-cart-body] input,[data-reference-cart-body] button,.bobbo-cart-form input,.bobbo-cart-form button').forEach(el=>el.disabled=false);}
  }
  function closeOverlays() {
    document.querySelectorAll('dialog[open]').forEach(d => d.close());
    const drawer = document.getElementById('menuDrawer');
    if (drawer) { drawer.hidden = true; drawer.setAttribute('aria-hidden', 'true'); drawer.classList.remove('is-open'); }
    document.querySelectorAll('.js-menu-drawer-trigger').forEach(b => b.setAttribute('aria-expanded','false'));
    if (returnFocus) returnFocus.focus();
    document.body.classList.remove('reference-scroll-locked');
    document.querySelector('.reference-menu-backdrop')?.remove();
  }
  function showCartDrawer(trigger) {
    const drawer = document.querySelector('#ReferenceCartDrawer');
    if (!drawer) return;
    returnFocus = trigger || document.activeElement;
    if (!drawer.open) {
      drawer.showModal();
      drawer.querySelector('[data-reference-cart-body]').scrollTop = 0;
    }
    document.body.classList.add('reference-scroll-locked');
  }
  async function openCartDrawer(trigger,cart) {
    showCartDrawer(trigger);
    if(cartAddTask){try{await cartAddTask;}catch{}return;}
    await refreshCart(cart);
  }
  // Show feedback before the first network round trip; never invent cart totals.
  async function addToCart(body,headers,trigger) {
    const offers=window.BobboOffers;
    if(cartAddTask || offers?.pendingUpdate)return {added:false};
    ++cartRevision; // Discard reads started before this mutation.
    const drawer=document.querySelector('#ReferenceCartDrawer');
    const content=document.querySelector('[data-reference-cart-body]');
    const footer=document.querySelector('[data-reference-cart-footer]');
    if(content)content.innerHTML='<p role="status">Adding to your cart…</p>';
    if(footer)footer.hidden=true;
    if(drawer)drawer.setAttribute('aria-busy','true');
    showCartDrawer(trigger);
    if(offers)offers.adding=true;
    const task=(async()=>{
      const response=await fetch(root+'cart/add.js',{method:'POST',headers,body});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description || 'Unable to add this item.');
      if(content)content.innerHTML='<p role="status">Updating your cart and offers…</p>';
      return {added:true,refreshed:await refreshCart()};
    })();
    cartAddTask=task;
    // Checkout and quantity updates must wait for the full gift reconciliation.
    const pending=task.then(result=>result.refreshed,()=>false);
    if(offers)offers.pendingUpdate=pending;
    try{return await task;}
    catch(error){
      if(content)content.innerHTML='<p role="status">'+escapeHtml(error.message)+'</p><a href="'+root+'cart">View cart</a>';
      throw error;
    } finally {
      cartAddTask=null;
      if(offers){offers.adding=false;if(offers.pendingUpdate===pending)offers.pendingUpdate=null;}
      if(drawer)drawer.removeAttribute('aria-busy');
    }
  }
  if(window.BobboOffers)window.BobboOffers.addToCart=addToCart;
  function setAccordion(trigger, expanded) {
    const content=document.getElementById(trigger.getAttribute('aria-controls'));
    if(!content)return;
    trigger.setAttribute('aria-expanded',String(expanded));
    content.hidden=!expanded;
    content.classList.toggle('open',expanded);
    content.style.maxHeight=expanded?'none':'0px';
    trigger.closest('.accordion__item')?.classList.toggle('accordion--open',expanded);
  }
  async function add(form,trigger) {
    if (form.dataset.busy) return;
    if (form.querySelector('button[type="submit"]')?.disabled) return;
    if (form.dataset.referenceOnly === 'true') { message(note); return; }
    const data = new FormData(form);
    if (!data.get('id')) { message(note); return; }
    form.dataset.busy = 'true';
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[role="status"]');
    if (button) button.disabled = true;
    try {
      if(status)status.textContent='Adding…';
      const result=await addToCart(data,{Accept:'application/json'},trigger || button || form);
      if(!result.added){if(status)status.textContent='Your cart is updating. Please wait.';return false;}
      if(status)status.textContent=result.refreshed?'Added to your cart.':'Item added. Open your cart to see the updated total.';
      return true;
    } catch (error) { if (status) status.textContent = error.message; else message(error.message); return false; }
    finally { delete form.dataset.busy; if (button) button.disabled = false; }
  }
  document.addEventListener('submit', async e => {
    if(e.target.matches('.reference-collection-toolbar') && document.body.dataset.referencePreview==='true') {
      e.preventDefault();filterReference(e.target);return;
    }
    const form = e.target.closest('[data-reference-add]');
    if (form) { e.preventDefault(); await add(form); return; }
  });
  document.addEventListener('click', async e => {
    const hotspotChoice = e.target.closest('[data-bobbo-hotspot],[data-bobbo-hotspot-step]');
    if (hotspotChoice) {
      const section = hotspotChoice.closest('[data-bobbo-hotspots]');
      const slides = [...section.querySelectorAll('[data-bobbo-hotspot-slide]')];
      const current = Number(section.dataset.activeSlide || 0);
      const index = Math.max(0, Math.min(slides.length - 1, hotspotChoice.dataset.bobboHotspot !== undefined ? Number(hotspotChoice.dataset.bobboHotspot) : current + Number(hotspotChoice.dataset.bobboHotspotStep)));
      section.dataset.activeSlide = index;
      slides.forEach((slide,i) => slide.hidden = i !== index);
      section.querySelector('[data-bobbo-hotspot-count]').textContent = index + 1;
      section.querySelectorAll('[data-bobbo-hotspot]').forEach(button => { const active = Number(button.dataset.bobboHotspot) === index; button.setAttribute('aria-pressed',String(active)); button.classList.toggle('hotspot-item--active',active); });
      section.querySelector('[data-bobbo-hotspot-step="-1"]').disabled = index === 0;
      section.querySelector('[data-bobbo-hotspot-step="1"]').disabled = index === slides.length - 1;
      return;
    }
    const link=e.target.closest('a[href]');
    if(link && !e.ctrlKey && !e.metaKey && !e.shiftKey && !link.target){const url=new URL(link.href,location.origin);if(url.origin===location.origin && previewRoutes[url.pathname]){e.preventDefault();const target=new URL(previewRoutes[url.pathname],location.origin);url.searchParams.forEach((v,k)=>target.searchParams.set(k,v));target.hash=url.hash;location.href=target.href;return;}}
    const cartTrigger=e.target.closest('.js-header-cart-status-btn');
    if(cartTrigger){e.preventDefault();await openCartDrawer(cartTrigger);return;}
    const cartStep=e.target.closest('[data-cart-quantity-step]');
    if(cartStep){const input=cartStep.closest('[data-cart-quantity]').querySelector('input');input.value=Math.max(0,(parseInt(input.value,10)||0)+Number(cartStep.dataset.cartQuantityStep));input.dispatchEvent(new Event('change',{bubbles:true}));return;}
    const remove=e.target.closest('[data-cart-remove]');if(remove){await updateCart(remove.dataset.cartRemove,0);return;}
    const open = e.target.closest('.js-menu-drawer-trigger');
    if (open) {
      const drawer = document.getElementById('menuDrawer');
      if (!drawer) return;
      returnFocus = open; drawer.hidden = false; drawer.setAttribute('aria-hidden','false'); drawer.classList.add('is-open');
      open.setAttribute('aria-expanded','true'); document.body.classList.add('reference-scroll-locked');
      drawer.querySelector('button,a')?.focus(); return;
    }
    if (e.target.closest('[data-close-dialog],.js-menu-drawer-btn-close,.js-drawer-overlay')) { closeOverlays(); return; }
    const accordion = e.target.closest('.js-accordion-trigger');
    if (accordion) {
      const expanded = accordion.getAttribute('aria-expanded') === 'true';
      setAccordion(accordion,!expanded); return;
    }
    const step = e.target.closest('[data-quantity-step]');
    if (step) {
      const input = step.closest('form').querySelector('[name="quantity"]');
      input.value = Math.max(1,Number(input.value||1)+Number(step.dataset.quantityStep)); input.dispatchEvent(new Event('change',{bubbles:true})); return;
    }
    const image = e.target.closest('[data-image-zoom]');
    if (image) {
      let dialog = document.getElementById('ReferenceZoom');
      if (!dialog) { dialog=document.createElement('dialog');dialog.id='ReferenceZoom';dialog.innerHTML='<button type="button" data-close-dialog aria-label="Close">×</button><img alt="Product detail">';document.body.appendChild(dialog); }
      returnFocus=image;dialog.querySelector('img').src=image.dataset.imageZoom;dialog.showModal();return;
    }
    if (e.target.closest('[data-reference-unavailable]')) { message(note);return; }
    const quick = e.target.closest('[data-reference-quickadd], [data-product-url].hdn-qb-wide, [data-product-url].hdn-qb-wide2, [data-product-url].quickbuy__btn');
    if (quick) {
      e.preventDefault(); const handle=quick.dataset.referenceQuickadd || quick.dataset.productUrl.split('/products/')[1];
      try {
        const response=await fetch(root+'products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'}});
        if (!response.ok) { message(note);return; }
        const product=await response.json();
        if (product.variants.length>1) { location.href=root+'products/'+handle;return; }
        const variant=product.variants.find(v=>v.available);
        if (!variant) { message('This product is currently unavailable.');return; }
        const form=document.createElement('form');form.innerHTML='<input name="id"><input name="quantity" value="1">';form.elements.id.value=variant.id;
        await add(form,quick);
      } catch { message('Unable to load this product. Please try again.'); } return;
    }
    const sizeGuide=e.target.closest('[data-size-guide]');
    if (sizeGuide) {
      const dimensions=sizeGuide.closest('[data-reference-product]')?.querySelector('[id^="size-dims-"]');
      const trigger=dimensions?.querySelector('.js-accordion-trigger');
      if(trigger){setAccordion(trigger,true);dimensions.scrollIntoView({behavior:'smooth',block:'center'});trigger.focus({preventScroll:true});}
      return;
    }
    const galleryStep=e.target.closest('[data-gallery-step]');
    if(galleryStep){const gallery=galleryStep.closest('.product__media-wrapper').querySelector('.reference-product-gallery');gallery.scrollBy({left:Number(galleryStep.dataset.galleryStep)*gallery.clientWidth,behavior:'smooth'});return;}
    const thumb=e.target.closest('[data-gallery-thumb]');
    if(thumb){const gallery=thumb.closest('.product__media-wrapper').querySelector('.reference-product-gallery');gallery.scrollTo({left:Number(thumb.dataset.galleryThumb)*gallery.clientWidth,behavior:'smooth'});gallery.parentElement.querySelectorAll('[data-gallery-thumb]').forEach(b=>b.setAttribute('aria-current',String(b===thumb)));return;}
    if (e.target.closest('[data-share-page],.js-social-share-copy-link')) { try { await navigator.clipboard.writeText(location.href);message('Link copied.'); } catch { message(location.href); }return; }
    if (e.target.closest('.js-country-switcher-btn')) { message('Currency and region options use the destination store’s configured Shopify Markets.');return; }
    if (e.target.closest('.reference-chat-button')) { location.href=root+'pages/contact';return; }
    const arrow=e.target.closest('.js-anmb-control-next,.js-anmb-control-prev');
    if (arrow) {
      const track=arrow.closest('sht-ann-bar').querySelector('.js-anmb-items');
      const total=track.children.length;let index=Math.round(track.scrollLeft/track.clientWidth);
      index=(index+(arrow.matches('.js-anmb-control-next')?1:-1)+total)%total;
      track.scrollTo({left:index*track.clientWidth,behavior:'smooth'});return;
    }
    const hotspot=e.target.closest('.js-product-hotspot,.hotspot__button,[data-hotspot-id]');
    if(hotspot){const buttons=[...hotspot.parentElement.querySelectorAll('button')];const index=Math.max(0,buttons.indexOf(hotspot));const track=hotspot.closest('.shopify-section')?.querySelector('.js-carousel-items');if(track)track.scrollTo({left:index*track.clientWidth,behavior:'smooth'});}
  });
  document.addEventListener('change',e=>{
    if(e.target.matches('[data-cart-line]'))updateCart(e.target.dataset.cartLine,Math.max(0,parseInt(e.target.value,10)||0));
    const cartStep=e.target.closest('[data-cart-quantity-step]');
    if(cartStep){const input=cartStep.closest('[data-cart-quantity]')?.querySelector('input');if(input){input.value=Math.max(0,(parseInt(input.value,10)||0)+Number(cartStep.dataset.cartQuantityStep));input.form?.requestSubmit();}return;}
    if(e.target.matches('[data-reference-sort]')) e.target.form.requestSubmit();
    if(e.target.matches('[data-reference-variant]')) {
      const option=e.target.selectedOptions[0], parent=e.target.closest('[data-reference-product]');
      parent.querySelector('[data-reference-price]').textContent=option.dataset.price;
      parent.querySelector('[data-reference-stock]').textContent=option.dataset.available==='true'?'In stock':'Sold out';
      parent.querySelector('[data-add-label]').textContent=option.dataset.available==='true'?'Add to cart':'Join waitlist';
      if(parent.dataset.referenceOnly!=='true') parent.querySelector('[type=submit]').disabled=option.dataset.available!=='true';
    }
  });
  document.addEventListener('keydown',e=>{
    if(e.key==='Escape')closeOverlays();
    if(e.key==='Tab'){
      const scope=document.querySelector('dialog[open],#menuDrawer.is-open');if(!scope)return;
      const nodes=[...scope.querySelectorAll('a[href],button,input,select,textarea')].filter(n=>!n.disabled&&n.offsetParent!==null);
      const first=nodes[0],last=nodes.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
    }
  });
  function filterReference(form) {
    const data=new FormData(form), grid=form.nextElementSibling;
    const sort=data.get('sort_by'), available=data.getAll('filter.v.availability');
    const low=data.get('filter.v.price.gte'),high=data.get('filter.v.price.lte');
    const cards=[...grid.querySelectorAll('[data-reference-card]')];
    cards.forEach((card,i)=>{
      if(!card.dataset.originalOrder)card.dataset.originalOrder=String(i+1);
      const price=Number(card.dataset.price)/100;
      card.hidden=Boolean((available.length&&!available.includes(card.dataset.available==='true'?'1':'0'))||(low!==''&&price<Number(low))||(high!==''&&price>Number(high)));
    });
    cards.sort((a,b)=>sort==='price-ascending'?Number(a.dataset.price)-Number(b.dataset.price):sort==='price-descending'?Number(b.dataset.price)-Number(a.dataset.price):sort==='title-ascending'?a.dataset.title.localeCompare(b.dataset.title):Number(a.dataset.originalOrder)-Number(b.dataset.originalOrder)).forEach(card=>grid.appendChild(card));
    form.querySelector(':scope > span').textContent=cards.filter(c=>!c.hidden).length+' products';
    let empty=grid.querySelector('.reference-preview-empty');
    if(!empty){empty=document.createElement('p');empty.className='reference-preview-empty w-100';empty.textContent='No products found. Try clearing your filters.';grid.appendChild(empty);}
    empty.hidden=cards.some(c=>!c.hidden);
    form.querySelector('details').open=false;
  }
  function initialize() {
    document.querySelectorAll('.card__media .img-second').forEach(img=>{
      if(img.dataset.hoverReady)return;img.dataset.hoverReady='true';
      const update=()=>img.closest('.card__media').classList.toggle('reference-hover-ready',img.complete&&img.naturalWidth>0);
      img.addEventListener('load',update);img.addEventListener('error',update);update();
    });
    document.querySelectorAll('.image-loader').forEach(e=>e.classList.add('image-loader--loaded'));
    document.querySelectorAll('.anm').forEach(e=>e.classList.add('animated'));
    document.querySelectorAll('sht-clps-rgn').forEach(el=>{
      const props=JSON.parse(el.dataset.properties||'{}');
      if(props.isCollapsibleOnDesktop===false && props.isCollapsibleOnMobile===false){el.querySelectorAll('[hidden]').forEach(e=>e.hidden=false);el.querySelector('button')?.setAttribute('aria-expanded','true');}
    });
    document.querySelectorAll('.product__description .rte p').forEach(el=>{if(!el.textContent.trim()&&!el.children.length)el.remove();});
    document.querySelectorAll('details').forEach(d=>{if(d.dataset.referenceReady)return;d.dataset.referenceReady='true';d.addEventListener('toggle',()=>{d.classList.toggle('is-open',d.open);d.querySelector('summary')?.setAttribute('aria-expanded',String(d.open));});});
    document.querySelectorAll('.reference-product-gallery').forEach(g=>{if(g.dataset.referenceReady)return;g.dataset.referenceReady='true';g.addEventListener('scroll',()=>{g.parentElement.querySelector('[data-gallery-count]').textContent=(Math.round(g.scrollLeft/g.clientWidth)+1)+' / '+g.children.length;},{passive:true});});
    document.querySelectorAll('.reference-gallery-thumbs button:first-child').forEach(b=>{if(!b.parentElement.querySelector('[aria-current=true]'))b.setAttribute('aria-current','true');});
    document.querySelectorAll('.js-anmb-item a').forEach(e=>e.removeAttribute('tabindex'));
    const ann=document.querySelector('.js-anmb-section');const header=document.querySelector('.js-sticky-header');
    document.documentElement.style.setProperty('--hdn-ann-h',(ann?.offsetHeight||0)+'px');
    document.documentElement.style.setProperty('--hdn-hdr-h',(header?.offsetHeight||0)+'px');
    if (innerWidth > 768) document.querySelectorAll('.js-footer .js-accordion-content').forEach(el=>{el.style.maxHeight='none';el.hidden=false;});
  }
  initialize();addEventListener('resize',initialize);document.addEventListener('shopify:section:load',initialize);
})();
